import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { useAuth } from '@/hooks/use-auth'

export const DefaultNotFoundPage = () => {
  const isMdAndSmaller = useMediaQuery('down', 'md')
  const { isAuthorized } = useAuth()

  return (
    <div className="flex h-[100dvh] flex-col items-center justify-center gap-6 bg-gradient-primary-vertical">
      <Typography
        className="text-[130px] md:text-[96px]"
        color="primary"
        variant="h1"
      >
        404
      </Typography>
      <div className="flex flex-col gap-2 text-center">
        <Typography
          color="text.primary"
          variant={isMdAndSmaller ? 'h6' : 'h5'}
        >
          <FormattedMessage id="notFound.title" />
        </Typography>
        <Typography
          color="text.secondary"
          variant={isMdAndSmaller ? 'body3' : 'body2'}
        >
          <FormattedMessage id="notFound.description" />
        </Typography>
      </div>

      <Button
        viewTransition
        color="primary"
        component={Link}
        to={isAuthorized ? '/app/rewards/' : '/'}
        variant="contained"
      >
        <FormattedMessage id="common.controls.backToHome" />
      </Button>
    </div>
  )
}
